
export function useRouterHelper(){

    const getSlug       = (slugs, key, lang) => {

        const selectedLanguage      = lang || jinkosoft_app_data.selected_language

        return slugs[selectedLanguage][key]
    }

    return {
        getSlug
    }
}